import UserExpense from './EmployeeExpense';
import AccountCodeContainer from './AccountCodeContainer';

export default class EditDayEntry {
    accountNumber?: number;
    clientNumber?: number;
    prospectNumber?: number;
    sectionNumber?: number;
    unitNumber?: number;
    compensationType?: string;
    hours?: number;
    periodNo?: string;
    selectedAccountCodeContainer?: AccountCodeContainer;
    tmDate?: string;
    tmId?: number;
    tsdNo?: string;
    userExpenses: UserExpense[];
    workDescription?: string;
}


// WEBPACK FOOTER //
// ./src/models/AP/EditDayEntry.ts